(function () {

    'use strict';

    angular
        .module('app.core')
        .service('DataService', [
            '$cookies',
            DataService
        ]);

    function DataService($cookies) {
        var service = this;
        var currentLocation = undefined;
        var currentLanguage = undefined;
        var currentTranslation = undefined;

        var SSO_TOKEN_COOKIE_NAME = 'sso_token';
        var SELECTED_LANGUAGE_COOKIE_NAME = 'selected_language';

        service.setCurrentLocation = setCurrentLocation;
        service.getCurrentLocation = getCurrentLocation;
        service.setCurrentLanguage = setCurrentLanguage;
        service.getCurrentLanguage = getCurrentLanguage;
        service.setCurrentTranslation = setCurrentTranslation;
        service.getCurrentTranslation = getCurrentTranslation;
        service.getSsoTokenFromCookie = getSsoTokenFromCookie;
        service.setSsoTokenIntoCookie = setSsoTokenIntoCookie;
        service.getLanguageCodeFromCookie = getLanguageCodeFromCookie;
        service.setLanguageCodeIntoCookie = setLanguageCodeIntoCookie;

        function setCurrentLocation(location) {
            currentLocation = location;
        }

        function getCurrentLocation() {
            return currentLocation;
        }

        function setCurrentLanguage(Language) {
            currentLanguage = Language;
        }

        function getCurrentLanguage() {
            return currentLanguage;
        }

        function setCurrentTranslation(translation) {
            currentTranslation = translation;
        }

        function getCurrentTranslation() {
            return currentTranslation;
        }

        function getSsoTokenFromCookie() {
            return $cookies.get(SSO_TOKEN_COOKIE_NAME);
        }

        function setSsoTokenIntoCookie(ssoToken) {
            var exp = new Date();
            exp = new Date(exp.getFullYear() + 1, exp.getMonth(), exp.getDate());
            $cookies.put(SSO_TOKEN_COOKIE_NAME, ssoToken, {expires: exp, path:'/'});
        }

        function getLanguageCodeFromCookie() {
            return $cookies.get(SELECTED_LANGUAGE_COOKIE_NAME);
        }

        function setLanguageCodeIntoCookie(langCode) {
            var exp = new Date();
            exp = new Date(exp.getFullYear() + 1, exp.getMonth(), exp.getDate());
            $cookies.put(SELECTED_LANGUAGE_COOKIE_NAME, langCode, {expires: exp, path:'/'});
        }
    }

})();



// WEBPACK FOOTER //
// ./app/core/service/DataService.js